import React, { useState } from 'react';
import { CheckCircle, Send } from 'lucide-react';

const NewsletterSection = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false);

  return (
    <div className="container" style={{ marginTop: 'var(--space-3xl)', paddingBottom: 'var(--space-4xl)' }}>
      <div className="newsletter">
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h3 style={{ color: '#fff', fontSize: '1.75rem', marginBottom: '0.5rem' }}>Stay Connected</h3>
          <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '440px', margin: '0 auto' }}>
            Join our newsletter for impact stories, updates, and ways to make a difference.
          </p>
          {newsletterSubmitted ? (
            <div style={{ marginTop: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', color: '#fff' }}>
              <CheckCircle size={20} /> Thank you for subscribing!
            </div>
          ) : (
            <div className="newsletter-input-group">
              <input
                className="newsletter-input"
                type="email"
                placeholder="Enter your email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
              />
              <button
                className="btn btn-gold"
                onClick={() => { if(newsletterEmail) setNewsletterSubmitted(true); }}
              >
                Subscribe <Send size={16} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsletterSection;
